import usuariosRotas from './usuarios/UsuariosRotas'
import perfilAcessoRotas from './perfisacesso/PerfilAcessoRotas'
import regraAcessoRotas from './regrasacesso/RegrasAcessoRota'

export default {
  path: 'controleacesso',
  name: 'ControleAcesso',
  component: {
    render (c) { return c('router-view') }
  },
  children: [
    usuariosRotas,
    perfilAcessoRotas,
    regraAcessoRotas
  ]
}



// WEBPACK FOOTER //
// ./src/modulos/admin/controleacesso/ControleAcessoRotas.js